import {
  AnnounceMode,
  IClinAnnounceBarProps
} from '../../components/ClinAnnounceBar/ClinAnnounceBar'

import { ORDER_SUCCESS_MESSAGE } from './maOrderConfirmationCopy'

/** CLOS-13488 — success banner shown once after booking redirect. */
export function buildOrderSuccessAnnounce(): IClinAnnounceBarProps {
  return {
    title: ' ',
    message: ORDER_SUCCESS_MESSAGE,
    mode: AnnounceMode.Success,
    isDismissibleText: true
  }
}
